<div class="bg-white">
  <h1 class="h3 p-3">{{tender.name}}</h1>

  <div class="table-responsive px-3">
    <table class="table table-sm table-bordered">
      <thead>
        <tr>
          <th class="text-nowrap small fw-normal">Location</th>
          <th class="text-nowrap small fw-normal">City</th>
          <th class="text-nowrap small fw-normal">Country</th>
          <th class="text-nowrap small fw-normal">Volume</th>
          <th class="text-nowrap small fw-normal">Period</th>
          <th class="text-nowrap small fw-normal">Supplier</th>
          <th class="text-nowrap small fw-normal">Offer</th>
          <th class="text-nowrap small fw-normal">Comment</th>
          <th class="text-nowrap small fw-normal">Status</th>
          <th class="text-nowrap small fw-normal">ITP</th>
          <th class="text-nowrap small fw-normal">Max Vol.</th>
          <th class="text-nowrap small fw-normal">Differential</th>
          <th class="text-nowrap small fw-normal">Currency</th>
          <th class="text-nowrap small fw-normal">Unit</th>
          <th class="text-nowrap small fw-normal">Base</th>
          <th class="text-nowrap small fw-normal">Bate</th>
          <th class="text-nowrap small fw-normal">Period</th>
          <th class="text-nowrap small fw-normal">Update</th>
          <th class="text-nowrap small fw-normal">Hookup</th>
          <th class="text-nowrap small fw-normal">Currency</th>
          <th class="text-nowrap small fw-normal">Unit</th>
          <th class="text-nowrap small fw-normal">Av. Uplift</th>
          <th class="text-nowrap small fw-normal">Fee 1</th>
          <th class="text-nowrap small fw-normal">Price</th>
          <th class="text-nowrap small fw-normal">Unit</th>
          <th class="text-nowrap small fw-normal">Fee 2</th>
          <th class="text-nowrap small fw-normal">Price</th>
          <th class="text-nowrap small fw-normal">Unit</th>
          <th class="text-nowrap small fw-normal">Fee 3</th>
          <th class="text-nowrap small fw-normal">Price</th>
          <th class="text-nowrap small fw-normal">Unit</th>
          <th class="text-nowrap small fw-normal">Total Fees</th>
          <th class="text-nowrap small fw-normal">Currency</th>
          <th class="text-nowrap small fw-normal">Unit</th>
          <th class="text-nowrap small fw-normal">Gap vs prev.</th>
          <th class="text-nowrap small fw-normal">Currency</th>
          <th class="text-nowrap small fw-normal">Unit</th>
          <th class="text-nowrap small fw-normal">Gap Total</th>
          <th class="text-nowrap small fw-normal">Cur. vs prev.</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let offer of offers; let i=index">
          <td class="text-nowrap">{{contract.location.iata}}</td>
          <td class="text-nowrap">{{contract.location.name}}</td>
          <td class="text-nowrap">{{contract.location.country?.name}}</td>
          <td class="text-nowrap">{{contract.volume | numberSpaces}} {{contract.units.code}}</td>
          <td class="text-nowrap">{{contract.dateStart | date: 'yyyy'}}</td>
          <td class="text-nowrap">
            <span *ngIf="contract.companyChild && contract.companyChild?.name">{{ contract.companyChild?.name }}</span>
            <span *ngIf="!(contract.companyChild && contract.companyChild?.name)">{{ contract.companyInfo }}</span>
          </td>
<!--            todo should be offers like 1,2,3... or not?-->
          <td class="text-nowrap">{{i + 1}}</td>
          <td class="text-nowrap">
            <jft-award-comment-icon [comment]="offer.awardComment"
              [airline]="$safeNavigationMigration(tender?.company?.name)"></jft-award-comment-icon>
            <span *ngIf="!offer.awardComment" class="text-muted">-</span>
          </td>
          <td class="text-nowrap">Current</td>
          <td class="text-nowrap">Sky Tanking</td>
          <td class="text-nowrap">100</td>
          <td class="text-nowrap">{{offer.bid?.differential?.price?.value }}</td>
          <td class="text-nowrap">{{offer.bid?.differential?.price?.currency?.code}}</td>
          <td class="text-nowrap">{{offer.bid?.differential?.units?.code}}</td>
          <td class="text-nowrap">
              {{(offer.bid?.index ? $safeNavigationMigration(offer.bid?.index?.index_code?.description)  : '') | slice:0:10 }}
              {{offer.bid?.marketPrice?.price ? 'market' : '' }}
          </td>
          <td class="text-nowrap">{{offer.bid?.index ? offer.bid?.index?.bate?.name  : '' }}</td>
          <td class="text-nowrap">{{offer.bid?.index ? offer.bid?.index?.averaging_offset?.name  : '' }}</td>
          <td class="text-nowrap">{{offer.bid?.index ? offer.bid?.index?.effective_day?.name  : '' }}</td>
          <td class="text-nowrap">28</td>
          <td class="text-nowrap">
              {{offer.bid?.index ? offer.bid?.index?.index_code?.currency  : '' }}
              {{offer.bid?.marketPrice?.price ? offer.bid?.marketPrice?.price?.['price']?.currency?.code : '' }}
          </td>
          <td class="text-nowrap">
              {{offer.bid?.index ? offer.bid?.index?.index_code?.unit  : '' }}
              {{offer.bid?.marketPrice?.price ? offer.bid?.marketPrice?.price?.['units']?.code : '' }}
          </td>
          <td class="text-nowrap">6700</td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length ? offer.bid?.volumeBasedFees[0].name  : '' }}</td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length ? offer.bid?.volumeBasedFees[0]?.price?.price?.value  : '' }}</td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length ? offer.bid?.volumeBasedFees[0]?.price?.units?.code  : '' }}</td>

          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length > 1 ? offer.bid?.volumeBasedFees[0].name  : '' }}</td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length > 1 ? offer.bid?.volumeBasedFees[0]?.price?.price?.value  : '' }}</td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length > 1 ? offer.bid?.volumeBasedFees[0]?.price?.units?.code  : '' }}</td>
          <td class="text-nowrap"></td>
          <td class="text-nowrap"></td>
          <td class="text-nowrap"></td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length ? calcTotalFees($safeNavigationMigration(offer.bid?.volumeBasedFees)) : ''}}</td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length ? offer.bid?.volumeBasedFees[0]?.price?.price?.value  : '' }}</td>
          <td class="text-nowrap">{{offer.bid?.volumeBasedFees.length ? offer.bid?.volumeBasedFees[0]?.price?.units?.code  : '' }}</td>
          <td class="text-nowrap"></td>
          <td class="text-nowrap"></td>
          <td class="text-nowrap"></td>
          <td class="text-nowrap"></td>
          <td class="text-nowrap"></td>
        </tr>
      </tbody>
    </table>
  </div>

</div>


